export function handleOptionalCall<Input = unknown, Output = unknown>(
  fn: (value: Input) => Output,
  value?: Input
): Output | undefined {
  return value ? fn(value) : undefined
}
